import { useColumnVisibility } from './useColumnVisibility'
import { MEISAI_ALWAYS_VISIBLE_F_KEYS, MEISAI_F_COLUMN_IDS } from '../utils/detailGridTypes'

export type MeisaiScreenKey = 'recipient-meisai-edit' | 'recipient-meisai-detail'

export function useMeisaiColumnVisibility(screenKey: MeisaiScreenKey) {
  return useColumnVisibility(screenKey, MEISAI_F_COLUMN_IDS, {
    alwaysVisible: [...MEISAI_ALWAYS_VISIBLE_F_KEYS],
  })
}

export default useMeisaiColumnVisibility
